var map = {
	"./1-1.png": 5993,
	"./1-2.png": 3999,
	"./1-3.png": 4350,
	"./1-4.png": 2724,
	"./1.png": 5155,
	"./2.png": 9829,
	"./3.png": 7770,
	"./4.png": 9387,
	"./bom1.png": 4784,
	"./bom2.png": 5779,
	"./go.png": 4356
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 9575;